import { SecureAction } from '../secure-actions';

export class ImportModelsSecureActions extends SecureAction {
  static readonly NAME = 'settings:model:import';
  static readonly crudActions = SecureAction.buildCrudActions(ImportModelsSecureActions.NAME);
  static readonly UPLOAD = new ImportModelsSecureActions(`${ImportModelsSecureActions.NAME}|${SecureAction.VERBS.UPLOAD}`);

  private constructor(name: string) {
    super(name);
  }
}
